import React, { Component }  from 'react';
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'

function Services (props) {
    const services = props.services.map(service => {
        return (                  
            <Card >
            <Card.Header>
                <Accordion.Toggle as={ Button } variant="link" eventKey={ service.id }>
                    <p className="accordionTitle">{ service.name }</p>
                </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={ service.id }>
                <Card.Body>{ service.description }</Card.Body>
            </Accordion.Collapse>
        </Card> 
        );
    });   

    return (   
        <React.Fragment>
        <div className="container">
            <div className="row row-content">
                <div className="col-12">
                    <h3>Our Services</h3>   
                    <Accordion defaultActiveKey="0">
                        { services }
                    </Accordion>            
                </div>
            </div>          
        </div>     
        </React.Fragment>               
        
    );
}

export default Services;